import { Activity, GitGraph, Settings, Users2 } from "lucide-react";
import { Button } from "@components/common/button";
import {
  Drawer,
  DrawerContent,
  DrawerTrigger,
} from "@components/common/drawer";
import useTranslator from "@hooks/use-translator";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@components/common/tooltip";
import { DictType } from "@pma/types";
import { useEffect, useState } from "react";
import { ProjectActivity } from "@components/activities/project-activity";
import ProjectMembers from "./project-members";
import ProjectSettings from "./project-settings";
import { useSearchParams } from "react-router-dom";

interface Props {
  project: DictType;
}
export default function ProjectToolbar({ project }: Props) {
  const [isOpen, setIsOpen] = useState(false);

  const [active, setActive] = useState("activity");
  const { translate } = useTranslator();

  const [searchParam] = useSearchParams();
  const taskParam = searchParam?.get("task");

  useEffect(() => {
    taskParam && setIsOpen(false);
  }, [taskParam]);
  return (
    <Drawer open={isOpen} onOpenChange={setIsOpen}>
      <div className="flex fixed bottom-20 md:bottom-5 left-1/2 right-1/2 -translate-x-1/2 z-20 w-[45px] animate-all transition-all ease-in-out duration-300 hover:w-[200px] overflow-hidden hover:overflow-visible items-center justify-between rounded-full animate-background-shine bg-primary/20 hover:bg-primary/50 p-1">
        <Tooltip>
          <TooltipTrigger>
            <Button
              variant="ghost"
              size="icon"
              onClick={() => {
                setActive("activity");
                setIsOpen(true);
              }}
              className="text-zinc-100 relative rounded-full hover:bg-gray-600 hover:text-zinc-100"
            >
              <Activity className="h-6 w-6 stroke-1" />
              <span className="sr-only">{translate("Activity")}</span>

              <span className="absolute top-2 right-2 block h-2 w-2 rounded-full bg-blue-500" />
            </Button>
          </TooltipTrigger>
          <TooltipContent>
            <span>{translate("Activity")}</span>
          </TooltipContent>
        </Tooltip>

        <Tooltip>
          <TooltipTrigger>
            <Button
              variant="ghost"
              size="icon"
              onClick={() => {
                setActive("members");
                setIsOpen(true);
              }}
              className="text-zinc-100 relative rounded-full hover:bg-gray-600 hover:text-zinc-100"
            >
              <Users2 className="h-6 w-6 stroke-1" />
              <span className="sr-only">{translate("Members")}</span>
            </Button>
          </TooltipTrigger>
          <TooltipContent>
            <span>{translate("Members")}</span>
          </TooltipContent>
        </Tooltip>

        <Tooltip>
          <TooltipTrigger>
            <Button
              variant="ghost"
              size="icon"
              onClick={() => {
                setActive("settings");
                setIsOpen(true);
              }}
              className="text-zinc-100 relative rounded-full hover:bg-gray-600 hover:text-zinc-100"
            >
              <Settings className="h-6 w-6 stroke-1" />
              <span className="sr-only">{translate("Settings")}</span>
            </Button>
          </TooltipTrigger>
          <TooltipContent>
            <span>{translate("Settings")}</span>
          </TooltipContent>
        </Tooltip>
      </div>
      <DrawerContent className="min-h-[60vh] p-4">
        {active === "activity" && <ProjectActivity project={project} />}
        {active === "members" && <ProjectMembers project={project} className="" />}
        {active === "settings" && <ProjectSettings project={project} />}
      </DrawerContent>
    </Drawer>
  );
}
